import React from 'react';
import _ from "lodash";
import hash from 'object-hash';
import {
  VERIFY_NEVER,
  VERIFY_RUNNING,
  VERIFY_SUCCESS,
  VERIFY_FAILED,
  VERIFY_CANCEL,
  WAITING,
  ERROR
} from '@/constants/verificationStatus';
import { simplifySignalNames } from './txtFunction';
import { IBIS_ODT, CUSTOM_ODT, IBIS_AMI_FILE_MODEL, AMI_OBJ_PARAM } from '@/services/Rocky/AMIModelHelper/constants';
import { EXPERIMENTS, EXPERIMENTS_RESULT } from '../../../constants/treeConstants';
import { changeIBISAMIModelToIBISModel, getSweepCopyByteData } from '../helper/setupData';
import ibisAMIConstructor from '../AMIModelHelper/libraryIbisAmiConstructor';
import { versionCompareSize } from '../../helper/dataProcess';
import { TRANSIENT } from '../constants';


const ICTypes = ['Controller', 'Memory']

export const PCB = 'pcb', PKG = 'pkg', DECAP_MODEL = 'decap_model', PIN = 'pins', DIE_MODEL = "die_model", SIMULATION = "simulation", CORNER = "corner";
export const DEFAULT_EXPERIMENT_COLUMNS = [/*DECAP_MODEL, DIE_MODEL,*/ PIN],
  PIN_MODEL_KEY = ['model', 'pinModels', 'powerOff'/*, 'ifIbisAdvancedOpen', 'ibisAdvancedOptions'*/, 'amiModelInfo', 'amiModel', 'amiModelUse', 'amiODTValue', 'removeDcOffset'];

const list = ['group', 'name', 'signalGroupName', 'pins', 'corner', 'simulation']
const statEyeConfigList = ["transientEngine", "simulationMode", "edgesNum", "crosstalkType", "eyeDiagramTriggering", "eyeDiagramTriggeringClockMode", "numberBits", "steadyState", "ignoreBits", "alignEye", "tolerance", "nImpulse"]

function getGroupInList(list, visibleOnly = false) {
  let group = {};
  if (list && list.length) {
    for (let item of list) {
      if ((visibleOnly && item.visible) || !visibleOnly) {
        group[item.component] = { ...item };
      }
    }
  }
  return group;
}

function getComponentList(content, key = CORNER, visibleOnly = false) {
  let list = []
  for (let info of content) {
    const { Interfaces, name } = info;
    for (let [_interface] of Interfaces.map((item, _index) => [item, _index])) {
      const data = _interface[key] && _interface[key].length ? _interface[key] : [];
      const addList = [...Object.values(getGroupInList(data, visibleOnly))]

      if (addList.length) {
        for (let addItem of addList) {
          const findIndex = list.findIndex(item => item.component === addItem.component)
          if (findIndex > -1) {
            list[findIndex].signalGroupList.push(name)
          } else {
            list.push({
              ...addItem,
              signalGroupList: [name]
            })
          }
        }
      }
    }
  }
  return list
}

function getExperimentColumns(experiments, base, columnsTitle) {

  const { content = [] } = base;
  const cornerList = getComponentList(content, 'corner', true);

  const _columnsTitle = columnsTitle.sort((a, b) => {
    const aFindIndex = list.findIndex(item => item === a)
    const bFindIndex = list.findIndex(item => item === b)
    return aFindIndex - bFindIndex;
  })

  let columns = [{
    title: '',
    dataIndex: 'group',
    width: 50,
  }, {
    title: '',
    dataIndex: 'direction',
    width: 90,
  }, {
    title: 'Name',
    dataIndex: 'name',
    width: 120,
  }, {
    title: 'StatEye Probe',
    dataIndex: 'statEye',
    width: 120,
  }, {
    title: 'Signal Group',
    dataIndex: 'signalGroupName',
    width: 120,
  }]
  _columnsTitle.forEach(key => {
    switch (key) {
      case PKG:
        columns.push({
          title: 'Component',
          dataIndex: 'pkg',
          width: 'pkg',
        })
        break;
      case CORNER:
        const addColumn = {
          title: 'Corner',
          dataIndex: 'corner',
          key: 'corner'
        }
        if (cornerList && cornerList.length) {
          addColumn.children = cornerList.map(item => {
            const { component } = item
            let title = component;
            const titleList = component.split('_');
            title = titleList.length > 1 ? titleList.filter((it, i) => i < titleList.length - 1).join("_") : component;
            return {
              title: title,
              // dataIndex: `corner-${component}`,
              // key: `corner-${component}`,
              dataIndex: component,
              key: component,
              signalGroupList: item.signalGroupList,
              width: 100
            }
          })
        } else {
          addColumn.width = 100
        }
        columns.push({
          ...addColumn
        })
        break;
      case SIMULATION:
        columns.push({
          title: 'Simulation Option',
          dataIndex: 'simulation',
          key: 'simulation'
        })
        break;
      case PIN:
        columns.push({
          title: 'Pin Buffer Model',
          dataIndex: 'pins',
          key: 'pins'
        })
        break;
      default: break;
    }
  })

  columns.push({
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 100,
  })
  return columns
}

function getExpTreeNode(exp_res = []) {
  return exp_res.map(item => {
    const { rootVerificationId, id, name } = item;
    return {
      id,
      key: EXPERIMENTS + '-' + id,
      name: name,
      dataType: EXPERIMENTS,
      verificationId: rootVerificationId,
      nodeClass: 'tree-node-experiment-name',
      icon: EXPERIMENTS,
      children: [{
        name: 'Result',
        key: EXPERIMENTS_RESULT + '-' + id /* + '-' + item.verificationId */,
        dataType: EXPERIMENTS_RESULT,
        nodeClass: 'tree-node-experiment-result-name',
      }]
    }
  })
}

function getExperimentStatus(status) {
  switch (status) {
    case VERIFY_RUNNING:
      return { title: 'Running', color: '#31aaf3' }
    case VERIFY_SUCCESS:
      return { title: 'Success', color: '#4dbd16' }
    case VERIFY_FAILED:
      return { title: 'Failed', color: '#b32222' }
    case VERIFY_CANCEL:
      return { title: 'Cancel', color: '#9d7ace' }
    case WAITING:
      return { title: 'Waiting', color: '#ff5500' }
    case ERROR:
      return { title: 'Error', color: '#dc143c', tooltip: 'Please check the error message in the corresponding monitor' }
    case VERIFY_NEVER:
    default:
      return { title: '', color: '#ffffff' };
  }
}

function getDataItemFromExp(expData, isBase, directionInfo, base, expList) {
  let dataItem = []
  const { name, status, content, id } = expData;
  if (content && content.length) {
    let isFirst = true;
    for (let ssnInfo of content) {
      const signalGroupName = ssnInfo.name
      let rowSpan = isFirst ? content.length : 0;
      const ssnId = `${id}-${ssnInfo.id}`;
      let cornerInfo = [], modelInfo = [];
      if (ssnInfo.Interfaces && ssnInfo.Interfaces.length) {
        cornerInfo = ssnInfo.Interfaces[0].corner ? ssnInfo.Interfaces[0].corner : [];
        modelInfo = getMergeModelInfo(ssnInfo.Interfaces)
      }
      const record = { name, signalGroupName, status: status, id: ssnId, rowSpan, experimentId: id, Interfaces: ssnInfo.Interfaces, signalGroupId: ssnInfo.id, config: expData.config, cornerInfo, modelInfo }
      let displayInfo = {};
      if (isBase) {
        const filterExpList = expList.filter(item => item.signalGroupName === signalGroupName);
        const obj = getBaseDisplayInfo(record, filterExpList)
        displayInfo = { ...obj }
      } else {
        const obj = getContentText(record, base)
        const { info } = getSimulationText(record)
        displayInfo = { ...obj, simulation: info }
      }
      dataItem.push({ ...record, displayInfo, directionInfo })
      isFirst = false
    }
  } else {
    dataItem.push({ name, status, id, rowSpan: 1, experimentId: id, directionInfo })
  }
  return dataItem;
}

function getDirectionInfo(exp, displayStatEye, base) {
  // statEyeProbeIds
  // runType Read/Write/ALL
  let directionInfo = { write: false, read: false, displayStatEye, statEye: [] }
  const configKeys = exp && exp.config ? Object.keys(exp.config) : []
  if (displayStatEye) {
    if (configKeys.includes('statEyeProbeIds')) {
      directionInfo.statEye = exp.config.statEyeProbeIds.length ? exp.config.statEyeProbeIds : []
    } else if (base && base.config && base.config.statEyeProbeIds && base.config.statEyeProbeIds.length) {
      directionInfo.statEye = base.config.statEyeProbeIds
    }
  }
  // if (displayStatEye && ((exp.config.statEyeProbeIds && exp.config.statEyeProbeIds.length) || (base && base.config && base.config.statEyeProbeIds && base.config.statEyeProbeIds.length))) {
  //   directionInfo.statEye = true
  // }

  if (configKeys.includes('runType')) {
    if (['ALL', 'Write'].includes(exp.config.runType)) {
      directionInfo.write = true;
    }
    if (['ALL', 'Read'].includes(exp.config.runType)) {
      directionInfo.read = true;
    }
  } else if (base && base.config && base.config.runType) {
    if (['ALL', 'Write'].includes(base.config.runType)) {
      directionInfo.write = true;
    }
    if (['ALL', 'Read'].includes(base.config.runType)) {
      directionInfo.read = true;
    }
  }
  return directionInfo
}

// function customSort(dataArray) {
//   const extractSuffix = (name) => {
//     const underscoreIndex = name.lastIndexOf('_');
//     return underscoreIndex !== -1 ? name.substring(underscoreIndex + 1) : '';
//   };

//   const extractTypeAndNumber = (name) => {
//     const type = name.startsWith('Byte') ? 'Byte' : (name.startsWith('CLK') ? 'CLK' : '');
//     const numMatch = name.match(/\d+/);
//     const number = numMatch ? parseInt(numMatch[0]) : 0;
//     return { type, number };
//   };

//   return dataArray.sort((a, b) => {
//     const aName = a.name || '';
//     const bName = b.name || '';

//     const aSuffix = extractSuffix(aName);
//     const bSuffix = extractSuffix(bName);

//     if (aSuffix !== bSuffix) {
//       if (aSuffix === '') return -1;
//       if (bSuffix === '') return 1;
//       return aSuffix.localeCompare(bSuffix);
//     }

//     const aInfo = extractTypeAndNumber(aName);
//     const bInfo = extractTypeAndNumber(bName);

//     if (aInfo.type !== bInfo.type) {
//       const typePriority = { 'Byte': 1, 'CLK': 2, '': 3 };
//       return typePriority[aInfo.type] - typePriority[bInfo.type];
//     }

//     return aInfo.number - bInfo.number;
//   });
// }

function getExperimentData(base, experiments = []) {
  const baseInfo = JSON.parse(JSON.stringify(base))
  const _experiments = [...experiments].filter(exp => exp.id);
  let data = [];

  const baseSimulateMode = base.config && base.config.option && base.config.option.simConfig && base.config.option.simConfig.simulateMode ? base.config.option.simConfig.simulateMode : TRANSIENT
  for (let exp of _experiments) {
    const expSimulateMode = exp.config && exp.config.option && exp.config.option.simConfig && exp.config.option.simConfig.simulateMode ? exp.config.option.simConfig.simulateMode : TRANSIENT
    const expIsStatEye = expSimulateMode === 'Transient' ? false : expSimulateMode === 'StatEye' || baseSimulateMode === 'StatEye' ? true : false;
    const expDirectionInfo = getDirectionInfo(exp, expIsStatEye, baseInfo)
    const dataItem = getDataItemFromExp(exp, false, expDirectionInfo, baseInfo)
    data = data.concat(dataItem)
  }
  let baseData = []
  if (baseInfo) {
    const baseIsStatEye = baseSimulateMode === 'StatEye' ? true : false;
    const baseDirectionInfo = getDirectionInfo(baseInfo, baseIsStatEye)
    const dataItem = getDataItemFromExp(baseInfo, true, baseDirectionInfo, null, data)
    baseData = baseData.concat(dataItem)
  }
  return [...baseData, ...data];
}

function getMergeModelInfo(Interfaces) {
  const _Interfaces = JSON.parse(JSON.stringify(Interfaces))
  let modelInfo = [];
  for (let Interface of _Interfaces) {
    if (Interface.pins) {
      for (let pinInfo of Interface.pins) {
        const findIndex = modelInfo.findIndex(item => item.component === pinInfo.component);
        if (findIndex === -1) {
          modelInfo.push(pinInfo);
        } else {
          modelInfo[findIndex].pinInfo = [...modelInfo[findIndex].pinInfo, ...pinInfo.pinInfo];
        }
      }
    }
  }
  return modelInfo
}

function getInfoFromChangeList(changeList) {
  let info = []
  let changeGroup = {}
  const params = ['model', 'powerOff', 'ifIbisAdvancedOpen', 'amiAdvancesInfo', 'stimulus', 'dutyCycle', 'jitter']
  changeList.forEach(item => {
    for (let key of params) {
      changeGroup = changeGroupHandle(item, key, changeGroup)
    }
  })
  for (let key of params) {
    if (changeGroup[key]) {
      let text = showPinBufferModelText(changeGroup[key]);
      if (text) {
        info.push({ value: text, key })
      }
    }
  }
  return info
}

function getBaseDisplayInfo(baseRecord, expRecords) {
  const displayInfo = {
    model: [],
    corner: [],
    simulation: []
  };

  const allKeys = {
    corner: new Set(),
    model: new Set(),
    simulation: new Set()
  };

  let changeList = []
  if (expRecords && expRecords.length) {
    const _dataSource = expRecords.filter(item => item.name !== 'Base')
    for (let data of _dataSource) {
      if (data.modelInfo && data.modelInfo.length) {
        const stimulus = getStimulusTextInSweeping(data.modelInfo, baseRecord.modelInfo);
        let _stimulus = []
        if (stimulus && stimulus.length) {
          _stimulus = getStimulusTextInSweeping(baseRecord.modelInfo, data.modelInfo);
        }
        for (let info of data.modelInfo) {
          const pinCurrentData = baseRecord.modelInfo.find(item => item.component === info.component)
          if (info && info.pinInfo) {
            for (let pin of info.pinInfo) {
              const _basePin = (pinCurrentData && pinCurrentData.pinInfo && pinCurrentData.pinInfo.length) ? pinCurrentData.pinInfo.find(item => item.pin === pin.pin && item.usage === pin.usage) : {}
              if (_basePin && Object.keys(_basePin).length > 4) {
                let _pinDiffModels = getPowerNDPUPDDiffInfo(pin, _basePin, true)
                const change = getPinChangeInfo(pin, _basePin, info, _stimulus, _pinDiffModels)
                const findChangeListIndex = changeList.findIndex(item => item.comp === change.comp && item.pin === change.pin && item.usage === change.usage)
                if (findChangeListIndex < 0) {
                  changeList.push(change);
                } else {
                  changeList[findChangeListIndex] = {
                    ...changeList[findChangeListIndex],
                    ...change
                  };
                }

              }
            }
          }
        }
      }

      if (data.displayInfo) {
        if (data.displayInfo.corner && data.displayInfo.corner.length) {
          data.displayInfo.corner.forEach(item => {
            allKeys.corner.add(item.key);
          });
        }

        if (data.displayInfo.simulation && data.displayInfo.simulation.length) {
          let filterList = []
          if (data.displayInfo.simulation.find(item => item.key === 'simulateMode')) {
            filterList = [...statEyeConfigList]
          }
          data.displayInfo.simulation.forEach(item => {
            if (!filterList.includes(item.key)) { allKeys.simulation.add(item.key); }
          });
        }
      }
    }

    let info = getInfoFromChangeList(changeList)
    displayInfo.model = info
  }

  Array.from(allKeys.corner).forEach(key => {
    const cornerItem = baseRecord.cornerInfo && baseRecord.cornerInfo.length ? baseRecord.cornerInfo.find(c => c.component === key) : {};
    displayInfo.corner.push({
      key: key,
      value: cornerItem && cornerItem.cornerInfo ? cornerItem.cornerInfo : "typ"
    });
  });

  const simConfig = baseRecord.config && baseRecord.config.option && baseRecord.config.option.simConfig ? baseRecord.config.option.simConfig : {}
  const statEyeConfig = simConfig.statEyeConfig || {};

  Object.keys(simConfig).forEach(key => {
    if (key !== "statEyeConfig" && allKeys.simulation.has(key)) {
      const result = getConfigTitle(key, simConfig);
      if (result.title) {
        displayInfo.simulation.push(result);
      }
    }
  });

  Object.keys(statEyeConfig).forEach(key => {
    if (allKeys.simulation.has(key)) {
      const result = getConfigTitle(key, statEyeConfig);
      if (result.title) {
        displayInfo.simulation.push(result);
      }
    }
  });

  if (allKeys.simulation.has("userDefinedNetList")) {
    const netlist = baseRecord.config && baseRecord.config.userDefinedNetList ? baseRecord.config.userDefinedNetList : [];
    displayInfo.simulation.push({
      title: "User Defined Netlist",
      key: "userDefinedNetList",
      value: netlist.map(item => item.fileName).join(", ") || "None"
    });
  }
  return displayInfo;
}

function getConfigTitle(key, config) {
  let title = key, value = config[key] || "";
  switch (key) {
    case 'clock':
      title = 'Clock'
      value = `${value}Hz`
      break;
    case 'cycles':
      title = 'Cycles'
      break;
    case 'timeStep':
      title = 'Time Step'
      value = `${value}s`
      break;
    case 'simulate':
      title = 'Simulator'
      break;
    case 'ngspiceMDFLM':
      title = 'MDFLM'
      break;
    case 'caClock':
      title = 'CA Clock'
      value = `${value}Hz`
      break;
    case 'caTimeStep':
      title = 'CA Time Step'
      break;
    case 'hspiceLicenses':
      title = 'Number of HSPICE Licenses'
      break;
    case 'hspiceCores':
      title = 'Number of Cores'
      break;
    case 'simulateMode':
      title = 'Simulation Type'
      break;
    case 'method':
      title = 'Method'
      value = config[key] === 'trap' ? 'Trapezoidal' : 'Gear';
      break;
    case 'pdaIsiWorstPattern':
      title = 'Use peak distortion analysis results in source'
      value = config[key] || false;
      break;
    case 'pdnWorstScenario':
      title = 'PDN Worst Scenario';
      value = config[key] || false;
      break;
    case 'pdnResonanceFreq':
      title = 'Resonance Frequency';
      value = `${value}Hz`
      break;
    // stateConfig
    case 'transientEngine':
      title = 'StatEye Method'
      break;
    case 'simulationMode':
      title = 'Simulation Mode'
      break;
    case 'edgesNum':
      title = 'Number of Edges'
      break;
    case 'crosstalkType':
      title = 'Crosstalk Type'
      break;
    case 'eyeDiagramTriggering':
      title = 'Eye-diagram Triggering'
      value = value == '1' ? 'Clock port' : 'Ideal clock'
      break;
    case 'eyeDiagramTriggeringClockMode':
      title = 'Triggering Clock Mode'
      value = value == '1' ? 'Jitter convolution' : 'Time domain trigger'
      break;
    case 'numberBits':
      title = 'Number of Bits';
      break;
    case 'steadyState':
      title = 'Steady State Noise'
      break;
    case 'ignoreBits':
      title = 'Ignore Bits'
      break;
    case 'alignEye':
      title = 'Align Eye'
      value = value.mode ? value.mode === 'CENT' ? `${value.mode} ${value.value}` : `${value.mode}` : ''
      break;
    case 'nImpulse':
      title = 'N_IMPULSE'
      break;
    case 'tolerance':
      title = 'BER for Measurement'
      break;
    case 'enableLinkEcc':
      title = 'Enable Link ECC'
      value = config[key] || false;
      break;
    case 'terminateOption':
      title = 'Terminate unused ports'
      let terminateValue = config[key] && config[key].terminateValue ? config[key].terminateValue : '50';
      value = config[key] && config[key].enableTerminate ? `true ${terminateValue}Ω` : 'false';
      break;
    case 'advancedOptions':
      title = 'Advanced Options'
      let advanceOptions = '';
      if (config[key] && Array.isArray(config[key])) {
        config[key].forEach((item, index) => {
          if (index === 0) {
            advanceOptions += `${item.name}=${item.value}`;
          } else {
            advanceOptions += ` , ${item.name}=${item.value}`;
          }
        })
      }
      value = advanceOptions;
      break;
    case 'enableSElement':
      title = 'Use S-element to Wrap Touchstone'
      value = config[key] || false;
      break;
    default:
      break;
  }
  return { title, key, value }
}


function getSimulationText(record) {
  let children = <span></span>;
  let info = [];
  if (!record.config || !Object.keys(record.config).length) { return { children, info } }

  const config = record.config || {}
  // if (!Interfaces || !Interfaces.length || !base || !base.content) { return {} }
  if (record.name === 'Base') { return { children, info } } else {
    const { option, userDefinedNetList } = config;

    const simConfig = option && option.simConfig ? option.simConfig : {}

    const optionKeys = simConfig ? Object.keys(simConfig) : []

    if (optionKeys.length) {
      optionKeys.forEach(item => {
        if (item === "statEyeConfig") {
          if (!optionKeys.includes('simulateMode')) {
            for (let key in simConfig.statEyeConfig) {
              const data = getConfigTitle(key, simConfig.statEyeConfig)
              if (data) {
                info.push(data)
              }
            }
          }
        } else {
          const data = getConfigTitle(item, simConfig)
          if (data) {
            info.push(data)
          }
        }

      })
    }

    if (userDefinedNetList && userDefinedNetList.length) {
      const nameList = userDefinedNetList.map(item => item.fileName)
      info.push({ title: "User Defined Netlist", key: "userDefinedNetList", value: nameList.join(', ') })
    }
  }

  return { children, info }
}

function getContentText(record, base) {
  let model = [], corner = [], changeList = [];

  const Interfaces = record.Interfaces
  const componentMap = {};
  if (record.name === 'Base') { return { model } }

  if (!Interfaces || !Interfaces.length || !base || !base.content) { return { model } }
  let baseInfo = base.content.find(item => item.id === record.signalGroupId)
  baseInfo = JSON.parse(JSON.stringify(baseInfo))
  if (!baseInfo) { return {} }
  for (let interfaceInfo of Interfaces) {
    if (!interfaceInfo.pins || !interfaceInfo.pins.length) { continue }
    const findBaseInfo = baseInfo.Interfaces.find(item => item.interfaceId === interfaceInfo.interfaceId)
    const basePins = findBaseInfo && findBaseInfo[PIN] ? findBaseInfo[PIN] : [];
    const stimulus = getStimulusTextInSweeping(interfaceInfo.pins, basePins);
    for (let pinGroup of interfaceInfo.pins) {
      const component = pinGroup.component;
      if (pinGroup.pinInfo && pinGroup.pinInfo.length) {
        if (!componentMap[component]) {
          componentMap[component] = {
            driverSignals: new Set(),
            receiverSignals: new Set(),
            modelInfo: ''
          };
        }
        const currentBaseInfo = basePins.find(item => item.component === component)

        pinGroup.pinInfo.forEach(pin => {
          let _basePin = currentBaseInfo && currentBaseInfo.pinInfo.length ? currentBaseInfo.pinInfo.find(item => item.pin === pin.pin && item.usage === pin.usage) : {}
          let _pinDiffModels = getPowerNDPUPDDiffInfo(pin, _basePin)
          const change = getPinChangeInfo(pin, pin, pinGroup, stimulus, _pinDiffModels, _basePin)
          changeList.push(change);
        });
      }
    };
  };
  model = getInfoFromChangeList(changeList)

  const baseCorner = baseInfo && baseInfo.Interfaces && baseInfo.Interfaces.length && baseInfo.Interfaces[0].corner ? baseInfo.Interfaces[0].corner : [];

  record.cornerInfo.forEach(item => {
    const { component } = item;
    const currentBaseCorner = baseCorner.find(it => it.component === component) || null;
    if (currentBaseCorner && currentBaseCorner.cornerInfo) {
      const findInfo = record.cornerInfo.find(it => it.component === component)
      if (findInfo && findInfo.cornerInfo && findInfo.cornerInfo !== currentBaseCorner.cornerInfo) {
        corner.push({ key: findInfo.component, value: findInfo.cornerInfo })
      }
    }
  })

  return { model, corner }
}

function changeGroupHandle(obj, key, changeGroup) {
  const { signal, comp, usage } = obj;
  const param = obj[key];
  let _changeGroup = { ...changeGroup }
  if (param) {
    if (_changeGroup[key]) {
      const find = _changeGroup[key].find(i => i.comp === comp && i.usage === usage && i.value === param);
      if (find) {
        find.signals = [...new Set([...find.signals, signal])]
      } else {
        _changeGroup[key].push({ comp, usage, value: param, signals: [signal] })
      }
    } else {
      _changeGroup[key] = [{ comp, usage, value: param, signals: [signal] }]
    }
  }
  return _changeGroup
}

function showPinBufferModelText(group) {
  let text = [];
  for (let item of group) {
    const { comp, signals, value, usage } = item;
    if (comp && signals && signals.length) {
      const receiverSignalsTxt = simplifySignalNames(Array.from(signals))
      text.push(`${comp}(${usage})-${receiverSignalsTxt} ${value}`)
    }
  }
  return text.join("\n")
}

function getTitleValue(key, basePin) {
  const data = basePin[key];
  let title = "", value = data;
  // ['amiModel', 'amiModelUse', 'amiODTValue', 'amiModelUse', 'removeDcOffset', 'ifIbisAdvancedOpen']
  switch (key) {
    case 'amiModel':
      title = 'AMI Model Instantiation';
      value = data === IBIS_AMI_FILE_MODEL ? 'IBIS_AMI_FILE / IBIS_AMI_MODEL' : 'AMI_OBJ / AMI_PARAM'
      break;
    case 'amiModelUse':
      value = data === IBIS_ODT ? 'Use V/I table in .ibs' : 'Use custom';
      if (data === CUSTOM_ODT && basePin.amiODTValue) {
        value = `Use custom ${basePin.amiODTValue}Ohm`
      }
      break;
    case 'amiODTValue':
      value = `Use custom ${basePin.amiODTValue}Ohm`
      break;
    case 'removeDcOffset':
      title = 'Automatically Remove DC Offset';
      value = data ? 'True' : 'False';
      break;
    case 'ifIbisAdvancedOpen':
      title = 'Advanced Options';
      value = data && data === '1' ? "on" : 'off';
      break;
    default: break;
  }
  return { title, value }
}

function getJitterTitle(key) {
  switch (key) {
    case "RJPP":
      return 'Peak-to-peak jitter with BER';
    case "VNPP":
      return 'Peak-to-peak jitter with voltage noise';
    case "RJ":
      return 'Random Jitter';
    case "PJ":
      return 'Periodic Jitter';
    default: return "None"
  }
}

function getDCDValue(key) {
  switch (key) {
    case 0:
      return 'No DCD'
    case 1:
      return 'Constant DCD'
    case 2:
      return 'Uncorrelated triangular DCD variation'
    case 3:
      return 'Uncorrelated sinusoidal DCD variation'
    default: return "No DCD"
  }
}

function getPinChangeInfo(pin, basePin, data, stimulus, _pinDiffModels, findBasePinInfo) {
  let change = { comp: data.component, signal: pin.signal, pin: pin.pin, usage: pin.usage }
  if (pin.model) {
    change['model'] = basePin.model && basePin.model.modelName ? basePin.model.modelName : '';
  }

  if (!change['model']) {
    //When the models are not equal, the data below is basically not equal, so only the models are displayed as different
    let amiAdvancesInfo = []
    if (pin.amiModelInfo && pin.amiModelInfo.amiParameters && pin.amiModelInfo.amiParameters.length) {
      let filterParameters = [];
      if (basePin.amiModelInfo && basePin.amiModelInfo.amiParameters) {
        filterParameters = basePin.amiModelInfo.amiParameters.filter(item => pin.amiModelInfo.amiParameters.find(it => it.name === item.name))
      } else {
        filterParameters = [...pin.amiModelInfo.amiParameters]
      }
      if (filterParameters && filterParameters.length) {
        let txt = [];
        filterParameters.forEach(item => {
          txt.push(item.name + ' = ' + item.value)
        })
        amiAdvancesInfo.push(txt.join(', '))
      }
    }

    ['amiModel', 'amiModelUse', 'amiODTValue', 'removeDcOffset'].forEach(key => {
      if (pin[key]) {
        if (key === 'amiODTValue' && pin['amiModelUse']) { return }
        const { title, value } = getTitleValue(key, basePin)
        amiAdvancesInfo.push(title ? `${title} = ${value}` : value)
      }
    })

    if (amiAdvancesInfo && amiAdvancesInfo.length) {
      change['amiAdvancesInfo'] = amiAdvancesInfo.join(', ')
    }
  }


  if (pin.jitter && basePin.jitter) {
    let baseTypes = [];
    const keys = Object.keys(basePin.jitter)
    if (keys && keys.length && keys.includes('types')) {
      baseTypes = basePin.jitter.types
    } else {
      baseTypes = findBasePinInfo && findBasePinInfo.jitter && findBasePinInfo.jitter.types ? findBasePinInfo.jitter.types : []
    }
    // let baseTypes = basePin.jitter.types || []
    const baseTitleList = baseTypes.map(item => getJitterTitle(item))
    change.jitter = `jitter (${baseTitleList.join(', ')})`
  }

  if (pin.dutyCycle && basePin.dutyCycle) {
    let txtList = []
    if (basePin.dutyCycle.DCD) {
      txtList.push(basePin.dutyCycle.DCD)
    }

    if (basePin.dutyCycle.DCD_TYPE || basePin.dutyCycle.DCD_TYPE === 0) {
      txtList.push(getDCDValue(basePin.dutyCycle.DCD_TYPE))
    }
    change.dutyCycle = `DCD (${txtList.join(', ')})`
  }

  if (pin.powerOff) {
    change.powerOff = basePin.powerOff === '1' ? _pinDiffModels ? `powerOff ${_pinDiffModels}` : 'powerOff' : "powerOn";
  } else if (_pinDiffModels) {
    change.powerOff = _pinDiffModels
  }

  // if (pin.powerOff && basePin.powerOff === '1') {
  //   change.powerOff = basePin.powerOff === '1' ? 'powerOff' : "";
  // }

  ['ifIbisAdvancedOpen'].forEach(key => {
    if (pin[key]) {
      const { title, value } = getTitleValue(key, basePin)
      change[key] = title ? `${title} = ${value}` : value;
    }
  })

  if (stimulus && stimulus.length) {
    const current = stimulus.find(item => item.comp === data.component && item.pin === pin.pin && item.usage === pin.usage);
    if (current && current.text) {
      change['stimulus'] = current.text;
    }
  }

  return change
}

function sweepingNdInDiff(newIn, baseIn, key) {
  if (!newIn[key] && !baseIn[key]) {
    return false;
  }
  if ((newIn[key] && !baseIn[key])
    || (!newIn[key] && baseIn[key])
    || (hash(newIn[key]) !== hash(baseIn[key]))) {
    return true;
  }
  return false;
}

function sweepingNdInDiffListInfo(newIn, baseIn) {
  let diffTxt = [];
  ['tabs', 'slew', 'delay'].forEach(key => {
    if (sweepingNdInDiff(newIn, baseIn, key)) {
      if (key === 'tabs' && newIn.tabs) {
        diffTxt.push(`[${newIn.tabs}]`);
      } else if (key === 'slew' && !newIn[key]) {
        diffTxt.push('5%')
      } else if (newIn[key]) {
        // percent
        if (newIn[key].type && newIn[key].type === 'percent') {
          diffTxt.push(`${newIn[key].value}%`);
        } else if (newIn[key].value) {
          diffTxt.push(`${newIn[key].value}`);
        }
      }
    }
  })
  return diffTxt.join(', ')
}

function getPowerNDPUPDDiffInfo(pin = {}, basePin = {}, isBase) {
  let pinText = "";
  if (pin.powerOff === '1' || (!pin.powerOff && basePin.powerOff === '1')) {
    const pinModels = pin.pinModels;
    const basePinModels = basePin.pinModels
    const findPUInfo = (pinModels || []).find(item => item.pinName === "nd_pu") || {};
    const findPDInfo = (pinModels || []).find(item => item.pinName === "nd_pd") || {};
    const baseFindPUInfo = (basePinModels || []).find(item => item.pinName === "nd_pu");
    const baseFindPDInfo = (basePinModels || []).find(item => item.pinName === "nd_pd");

    if (!pinModels || !pinModels.length) {
      if (pin.powerOff === '1') {
        if (baseFindPUInfo) {
          pinText += ` PU = ${baseFindPUInfo.voltage}V`;
        }
        if (baseFindPDInfo) {
          pinText += ` PD = ${baseFindPDInfo.voltage}V`;
        }
      }
    } else if (findPUInfo) {
      if (pin.powerOff && pin.powerOff !== basePin.powerOff) {
        if (isBase) {
          if (baseFindPUInfo) {
            pinText += ` PU = ${baseFindPUInfo.voltage}V`;
          }
          if (baseFindPDInfo) {
            pinText += ` PD = ${baseFindPDInfo.voltage}V`;
          }
        } else {
          pinText += ` PU = ${findPUInfo.voltage}V`;
          pinText += ` PD = ${findPDInfo.voltage}V`;
        }
      } else {
        if (!baseFindPUInfo || findPUInfo.voltage !== baseFindPUInfo.voltage || findPDInfo.voltage !== baseFindPDInfo.voltage) {
          if (isBase) {
            if (baseFindPUInfo) {
              pinText += ` PU = ${baseFindPUInfo.voltage}V`;
            }
            if (baseFindPDInfo) {
              pinText += ` PD = ${baseFindPDInfo.voltage}V`;
            }
          } else {
            pinText += ` PU = ${findPUInfo.voltage}V`;
            pinText += ` PD = ${findPDInfo.voltage}V`;
          }
        }

        // if (!baseFindPUInfo || findPUInfo.voltage !== baseFindPUInfo.voltage) {
        //   if (isBase) {
        //     if (baseFindPUInfo) {
        //       pinText += ` PU = ${baseFindPUInfo.voltage}V`;
        //     }
        //   } else {
        //     pinText += ` PU = ${findPUInfo.voltage}V`;
        //   }

        // }
        // if (!baseFindPDInfo || findPDInfo.voltage !== baseFindPDInfo.voltage) {
        //   if (isBase) {
        //     if (baseFindPDInfo) {
        //       pinText += ` PD = ${baseFindPDInfo.voltage}V`;
        //     }
        //   } else {
        //     pinText += ` PD = ${findPDInfo.voltage}V`;
        //   }
        // }
      }
    }
  }

  return pinText
}

const ND_IN = 'nd_in', ND_EN = 'nd_en';
function getStimulusTextInSweeping(pins, basePins) {
  let text = [];
  for (let comp of pins) {
    const baseComp = basePins.find(item => item.component === comp.component);
    if (comp && comp.exist === false) {
      continue;
    } else if (baseComp && baseComp.pinInfo && comp.pinInfo) {
      for (let pin of comp.pinInfo) {
        if (pin.pinModels && pin.pinModels.length) {
          const basePin = baseComp.pinInfo.find(p => p.pin === pin.pin && p.usage === pin.usage);
          if (!basePin) { continue }
          let diff = false, baseIn = {};
          const newIn = pin.pinModels.find(item => item.pinName === ND_IN);
          let pinText = "";
          if (newIn) {
            if (!basePin.pinModels || !basePin.pinModels.length) {
              diff = true;
            } else {
              baseIn = basePin.pinModels.find(item => item.pinName === ND_IN);
              if (!baseIn) { continue }
              if (!diff && newIn.type !== baseIn.type) {
                diff = true
              }

              if (!diff && (newIn.type.includes('PRBS') || newIn.type.includes('CLK'))) {
                if (sweepingNdInDiff(newIn, baseIn, "tabs") || sweepingNdInDiff(newIn, baseIn, "slew") || sweepingNdInDiff(newIn, baseIn, "delay")) {
                  diff = true;
                } else if (newIn.type.includes('PRBS') && !newIn.tabs) {
                  newIn.tabs = baseIn.tabs;
                  diff = true;
                }
              }

              if (!diff && ['GND', 'VCC'].includes(newIn.type)) {
                const newEn = pin.pinModels.find(item => item.pinName === ND_EN);
                const baseEn = basePin.pinModels.find(item => item.pinName === ND_EN);
                if ((!newEn && baseEn) || (newEn && !baseEn) || newEn.type !== baseEn.type) {
                  diff = true;
                }
              }

              if (!diff && newIn.type === 'VEC' && newIn.stimulus.libraryId !== baseIn.stimulus.libraryId) {
                diff = true;
              }

            }
            if (diff) {
              switch (newIn.type) {
                case 'VEC':
                  pinText = newIn.stimulus.subckt ? newIn.stimulus.subckt : newIn.stimulus.fileName;
                  break;
                case newIn.type.includes('PRBS'):
                  pinText = `${newIn.type}${newIn.tabs}`;
                  break;
                case 'GND':
                case 'VCC':
                  const newEn = pin.pinModels.find(item => item.pinName === ND_EN);
                  pinText = newEn ? newEn.type : "";
                  break;
                default:
                  if ((newIn.type.includes('PRBS') || newIn.type.includes('CLK'))) {
                    const ndInDiffText = sweepingNdInDiffListInfo(newIn, baseIn)
                    pinText = ndInDiffText ? `${newIn.type} (${ndInDiffText})` : `${newIn.type}`;
                  } else {
                    pinText = newIn.type;
                  }
                  break;
              }
            }
          }
          if (pinText) {
            text.push({ comp: comp.component, pin: pin.pin, usage: pin.usage, text: pinText })
          }
        }
      }
    }
  }
  return text;
}

function createExperimentSignalGroupUI(info, type, isCreate) {
  const { content = [], Interfaces = [] } = info
  let data = {
    ...info
  }

  let list = Interfaces && Interfaces.length ? Interfaces : content
  if (isCreate) {
    list = list.map(item => ({ interfaceId: item.interfaceId }))
  }

  if (type === 'content') {
    data.content = list
    delete data.Interfaces
  } else {
    data.Interfaces = list
    delete data.content
  }
  return data;
}

function ExperimentSignalGroup({ id = '', name = "", status, Interfaces = [], content = [] }) {
  this.id = id;
  this.name = name;
  this.status = status;
  this.content = Interfaces && Interfaces.length ? Interfaces : content;
}

function ExperimentInterface({ interfaceId, name, pcb = {}, pkg = [], pins = [], model = [], corner = [], signals = [], powerNets = [] }) {
  this.interfaceId = interfaceId;
  this.name = name;
  this.pcb = pcb;
  this.pkg = pkg;
  this.pins = pins;
  this.model = model;
  this.corner = corner;
  this.signals = signals;
  this.powerNets = powerNets;
}


async function getBaseSweepingSSNData(list) {
  let signalGroupList = []
  for (let info of list) {
    const { interfaces, id, name, status, designId, version } = info;

    if (interfaces && interfaces.length) {
      let _newInterfaces = [...interfaces]
      if (versionCompareSize(version, '0.0.19')) {
        // delete amiModel to add the data in amiModel to model
        _newInterfaces = await changeIBISAMIModelToIBISModel(_newInterfaces)
      }
      const pcb = {
        id: designId
      };
      const _interfaces = getBaseSweepingInterfaceData(_newInterfaces, pcb)
      const ssn_info = new ExperimentSignalGroup({ id, name, status, Interfaces: _interfaces })
      signalGroupList.push(ssn_info)
    }
  }
  return signalGroupList
}

function getBaseSweepingContentData(content) {
  let newContent = {};
  // option
  ['option', 'pdn', 'statEyeProbeIds', 'runType', 'includePdn'].forEach(key => {
    newContent[key] = content[key]
  })

  return newContent
}

async function getUpdateModelInfo(comp) {
  let _model = comp.model ? { ...comp.model } : {};
  if ((!_model || !_model.libraryId) && (comp.amiModel && comp.amiModel.libraryId && comp.amiModel.fileName)) {
    _model = { ...comp.amiModel };
  }
  if ([IBIS_AMI, IBIS].includes(_model.libType)) {
    let isAmi = false;
    if (_model.libraryId && _model.fileName) {
      isAmi = await ibisAMIConstructor.getFileIsAmiPromise(_model.libraryId, _model.fileName);
    }
    _model = {
      ..._model,
      libType: IBIS,
      isAmi: isAmi
    };
  }
}


function getBaseSweepingInterfaceData(Interfaces, pcb) {
  let _Interfaces = []
  for (let item of Interfaces) {
    let pkg = [], pins = [], model = [], corner = [];

    const { Components, Signals, PowerNets, } = item.Content
    for (let comp of Components) {
      if (ICTypes.includes(comp.type)) {
        pkg.push({
          component: comp.name,
          part: comp.part,
          visible: false,
          pkgInfo: JSON.parse(JSON.stringify(comp.pkg))
        })

        pins.push({
          component: comp.name,
          pinInfo: JSON.parse(JSON.stringify(comp.pins))
        })

        model.push({
          component: comp.name,
          modelInfo: { ...comp.model }
        })

        corner.push({
          component: comp.name,
          cornerInfo: JSON.parse(JSON.stringify(comp.corner)),
          visible: false
        })
      }
    }
    const _Interface = new ExperimentInterface({ interfaceId: item.id, name: item.name, pcb, pkg, pins, model, corner, signals: Signals, powerNets: PowerNets });
    _Interfaces.push(_Interface);
  }
  return _Interfaces
}


function getModelDiff(model, comparativeModel) {
  if (model && comparativeModel) {
    if (model.libType !== comparativeModel.libType || model.libraryId !== comparativeModel.libraryId || model.modelName !== comparativeModel.modelName) {
      return comparativeModel
    }
  } else if ((model && !comparativeModel) || (!model && comparativeModel)) {
    return comparativeModel
  }
  return null
}

function getPinsDiffData(data, comparativeData, isJitterDuty) {
  const { model, powerOff, pinModels } = data

  let pinDiffData = {}
  if (comparativeData.model) {
    const diffModel = getModelDiff(model, comparativeData.model)
    if (diffModel) {
      pinDiffData.model = diffModel
    }

    if (comparativeData.model.libType === IBIS_AMI || (comparativeData.model.libType === IBIS && comparativeData.model.isAmi)) {
      const { amiDiffData } = getAMIDiffData(comparativeData.record, data)
      pinDiffData = { ...pinDiffData, ...amiDiffData }
    } else if (comparativeData.model.libType === IBIS) {
      const { ibisDiffData } = getIBISDiffData(comparativeData.record, data)
      pinDiffData = { ...pinDiffData, ...ibisDiffData }
    }

    if ((powerOff && !comparativeData.powerOff) || (!powerOff && comparativeData.powerOff === '1') || (powerOff && comparativeData.powerOff && powerOff !== comparativeData.powerOff)) {
      // power off不同
      pinDiffData.powerOff = comparativeData.powerOff
    }
  }

  if (pinModels && comparativeData.pinModels && !_.isEqual(pinModels, comparativeData.pinModels)) {
    pinDiffData.pinModels = comparativeData.pinModels
  }

  if (isJitterDuty) {
    const dataJitter = data.jitter ? data.jitter : { types: ["none"] }
    const diffJitter = getJitterDutyDiffData(dataJitter, comparativeData.record.jitter)
    if (diffJitter && Object.keys(diffJitter).length) {
      pinDiffData.jitter = diffJitter
    }
    const dataDutyCycle = data.dutyCycle && Object.keys(data.dutyCycle).length ? data.dutyCycle : { DCD: "0", DCD_TYPE: 0 }
    const diffDutyCycle = getJitterDutyDiffData(dataDutyCycle, comparativeData.record.dutyCycle)
    if (diffDutyCycle && Object.keys(diffDutyCycle).length) {
      pinDiffData.dutyCycle = diffDutyCycle
    }
  }

  return pinDiffData;
}

function getJitterDutyDiffData(data = {}, comparativeData = {}) {
  let _jitterDuty = {}

  const newKeys = [...new Set([...Object.keys(data), ...Object.keys(comparativeData)])]
  for (let key of newKeys) {
    if (key === 'types') {
      if ((data.types && !comparativeData.types && !data.types.includes('none')) || (data.types && comparativeData.types && (comparativeData.types.length !== data.types.length || comparativeData.types.find(item => !data.types.includes(item)) || data.types.find(item => !comparativeData.types.includes(item))))) {
        _jitterDuty.types = comparativeData.types || ['none']
      }
    } else if (!_.isEqual(data[key], comparativeData[key])) {
      // } else if (data[key] !== comparativeData[key]) {
      _jitterDuty[key] = comparativeData[key]
    }
  }
  return _jitterDuty
}

function getMultipleDisable(key, diffKey) {
  if (!diffKey.length) { return false }
  switch (key) {
    case 'model':
      if (diffKey.find(it => ['amiModelInfo', 'amiModel', 'amiModelUse', 'amiODTValue', 'removeDcOffset'].includes(it))) {
        return true
      }
      return false;
    case 'amiModel':
    case 'amiModelUse':
    case 'amiODTValue':
      if (diffKey.find(it => ['amiModelInfo', 'removeDcOffset', 'model'].includes(it))) {
        return true
      }
      return false;
    case 'amiModelInfo':
      if (diffKey.find(it => ['amiModel', 'removeDcOffset', 'model'].includes(it))) {
        return true
      }
      return false;
    case 'removeDcOffset':
      if (diffKey.find(it => ['amiModel', 'amiModelInfo', 'model'].includes(it))) {
        return true
      }
      return false;
    default:
      // It is a specific option in amiModelInfo
      if (diffKey.includes('amiModelInfo')) {
        if (diffKey.includes(key)) {
          return false
        } else {
          return true
        }
      } else if (diffKey.find(it => ['amiModel', 'removeDcOffset', 'model'].includes(it))) {
        return true
      }
      return false;
  }
}

function getAmiParametersDiff(amiParameters = [], comparativeAmiParameters) {
  let diffInfo = []
  for (let info of comparativeAmiParameters) {
    const { value, name } = info;
    const find = amiParameters.find(item => item.name === name)
    if (!find || find.value !== value) {
      diffInfo.push(info)
    }
  }
  return diffInfo
}

function getIBISDiffData(comparativeData, data) {
  let ibisDiffData = {}
  const { ifIbisAdvancedOpen, ibisAdvancedOptions } = data;
  if ((ifIbisAdvancedOpen === '0' && !comparativeData.ifIbisAdvancedOpen) || (comparativeData.ifIbisAdvancedOpen === '0' && !ifIbisAdvancedOpen)) {
    return { ibisDiffData };
  } else if (ifIbisAdvancedOpen !== comparativeData.ifIbisAdvancedOpen) {
    ibisDiffData.ifIbisAdvancedOpen = comparativeData.ifIbisAdvancedOpen
    if (comparativeData.ifIbisAdvancedOpen === '1') {
      ibisDiffData.ibisAdvancedOptions = comparativeData.ibisAdvancedOptions
    }
  } else if (ifIbisAdvancedOpen === '1' && comparativeData.ibisAdvancedOptions === ifIbisAdvancedOpen && !_.isEqual(comparativeData.ibisAdvancedOptions, ibisAdvancedOptions)) {
    ibisDiffData.ibisAdvancedOptions = comparativeData.ibisAdvancedOptions
  }
  return { ibisDiffData };
}


function getAMIDiffData(comparativeData, data, updateAdvancedObj) {
  let amiDiffData = {}, diffKeyList = [];

  const { amiModel, amiModelUse, amiODTValue, removeDcOffset } = data;
  const amiParameters = data.amiParameters && data.amiParameters.length ? data.amiParameters : data.amiModelInfo && data.amiModelInfo.amiParameters ? data.amiModelInfo.amiParameters : [];
  const { amiModel: comparativeAmiModel, amiModelUse: comparativeAmiModelUse,
    amiODTValue: comparativeAmiODTValue, removeDcOffset: comparativeRemoveDcOffset } = comparativeData
  const comparativeAmiParameters = comparativeData.amiParameters ? comparativeData.amiParameters : comparativeData.amiModelInfo && comparativeData.amiModelInfo.amiParameters ? comparativeData.amiModelInfo.amiParameters : [];

  const diffAmiParameters = getAmiParametersDiff(amiParameters, comparativeAmiParameters)
  if (diffAmiParameters && diffAmiParameters.length) {
    const keyList = diffAmiParameters.map(item => item.name)
    diffKeyList = [...diffKeyList, 'amiModelInfo', ...keyList]
    amiDiffData.amiModelInfo = { amiParameters: diffAmiParameters }
  }

  if (updateAdvancedObj && updateAdvancedObj.valueType && updateAdvancedObj.name) {
    diffKeyList = [...diffKeyList, 'amiModelInfo', updateAdvancedObj.name]
    const _diffAmiParameters = comparativeAmiParameters.find(item => item.name === updateAdvancedObj.name);
    amiDiffData.amiModelInfo = { amiParameters: [_diffAmiParameters] }
  }

  if (amiModel !== comparativeAmiModel) {
    amiDiffData.amiModel = comparativeAmiModel
    diffKeyList.push('amiModel')

    if (comparativeAmiModel === AMI_OBJ_PARAM) {
      // updateAmiUse = true
      amiDiffData.amiModelUse = comparativeAmiModelUse || ""
      if (comparativeAmiModelUse === CUSTOM_ODT) {
        amiDiffData.amiODTValue = comparativeAmiODTValue
      }
    }
  } else if (amiModel === AMI_OBJ_PARAM) {
    if (amiModelUse !== comparativeAmiModelUse) {
      diffKeyList.push('amiModelUse')
      amiDiffData.amiModelUse = comparativeAmiModelUse || ""

      if (comparativeAmiModelUse === CUSTOM_ODT) {
        amiDiffData.amiODTValue = comparativeAmiODTValue
      }
    } else if (comparativeAmiModelUse === CUSTOM_ODT && amiODTValue !== comparativeAmiODTValue) {
      diffKeyList.push('amiODTValue')
      amiDiffData.amiODTValue = comparativeAmiODTValue
    }
  }

  if (removeDcOffset !== comparativeRemoveDcOffset) {
    diffKeyList.push('removeDcOffset')
    amiDiffData.removeDcOffset = comparativeRemoveDcOffset
  }
  return { amiDiffData, diffKeyList }
}

function getSimulationConfig(tempConfig, config, isSev) {
  const { statEyeConfig } = config
  const { statEyeConfig: tempStatEyeConfig } = tempConfig;
  let newConfig = JSON.parse(JSON.stringify({ ...config, ...tempConfig }))
  if (tempStatEyeConfig && Object.keys(tempStatEyeConfig).length) {
    newConfig.statEyeConfig = { ...statEyeConfig, ...tempStatEyeConfig }
  }

  return newConfig;
}

function getSimConfigDiff(newConfig, config, statEyeConfig = false) {
  const keys = Object.keys(newConfig);
  let diffConfig = {}
  let filterKeys = [...keys]
  filterKeys.forEach(item => {
    if (item === 'statEyeConfig') {
      let _statEyeConfig = newConfig.simulateMode !== config.simulateMode ? false : true;
      const diffStatEyeConfig = getSimConfigDiff(newConfig[item], config[item], _statEyeConfig)
      if (Object.keys(diffStatEyeConfig).length) {
        diffConfig.statEyeConfig = diffStatEyeConfig
      }
    } else if (['nImpulse', 'edgesNum'].includes(item)) {
      if ((newConfig.simulationMode && ['EDGE', 'STAT'].includes(newConfig.simulationMode)) || (!newConfig.simulationMode && ['EDGE', 'STAT'].includes(config.simulationMode))) {
        if (newConfig[item] !== config[item]) {
          diffConfig[item] = newConfig[item]
        }
      }
    } else if (['tolerance'].includes(item)) {
      if (!config[item]) {
        if (!(newConfig[item].length === 1 && newConfig[item][0] === "1e-20")) {
          diffConfig[item] = newConfig[item]
        }
      } else if (config[item] && !_.isEqual(newConfig[item], config[item])) {
        diffConfig[item] = newConfig[item]
      }
    } else if ((!_.isEqual(newConfig[item], config[item])) && (!statEyeConfig || (statEyeConfig && newConfig[item] && config[item]))) {
      diffConfig[item] = newConfig[item]
    }
  });
  return diffConfig
}

function getSaveConfig(Config, includePdn, isSEV) {
  function getProp(obj, prop, defaultValue) {
    return obj && obj[prop] !== undefined ? obj[prop] : defaultValue;
  }
  function getValueUnit(obj, key, defaultValue, defaultUnit) {

    const value = getProp(obj[key], 'value', defaultValue)
    const unit = getProp(obj[key], 'unit', defaultUnit)
    return value + unit
  }

  let newConfig = {};
  [{ key: 'clock', defaultValue: '', defaultUnit: 'M' },
  { key: 'timeStep', defaultValue: '', defaultUnit: 'n' },
  { key: 'pdnResonanceFreq', defaultValue: '123', defaultUnit: 'M' }].forEach(item => {
    newConfig[item.key] = getValueUnit(Config, item.key, item.defaultValue, item.defaultUnit)
  });

  if (Config.caClock) {
    newConfig.caClock = getValueUnit(Config, 'caClock', '', 'M')
  }

  if (Config.caTimeStep) {
    newConfig.caTimeStep = getValueUnit(Config, 'caTimeStep', '', 'n')
  }

  const isStateEye = Config.simulateMode === 'StatEye' ? true : false;
  const _config = {
    timeStep: newConfig.timeStep,
    clock: newConfig.clock,
    pdnResonanceFreq: newConfig.pdnResonanceFreq,
    caClock: newConfig.caClock || "",
    caTimeStep: newConfig.caTimeStep || "",
    cycles: getProp(Config, 'cycles', ''),
    simulate: getProp(Config, 'simulate', ''),
    cmd_2t_mode: getProp(Config, 'cmd_2t_mode', ''),
    ngspiceMDFLM: getProp(Config, 'ngspiceMDFLM', ''),
    pdnWorstScenario: getProp(Config, 'pdnWorstScenario', ''),
    pdaIsiWorstPattern: getProp(Config, 'pdaIsiWorstPattern', ''),
    simulateMode: isStateEye ? 'StatEye' : 'Transient',
    method: getProp(Config, 'method', 'trap'),
    enableLinkEcc: getProp(Config, 'enableLinkEcc', ''),
    advancedOptions: getProp(Config, 'advancedOptions', []),
    terminateOption: getProp(Config, 'terminateOption', { enableTerminate: false, terminateValue: "50" }),
    enableSElement: getProp(Config, 'enableSElement', ''),
  };
  if (isStateEye) {
    let statEyeCfg = Config.statEyeConfig || {};
    _config.statEyeConfig = {
      transientEngine: getProp(statEyeCfg, 'transientEngine', 'HPP'),
      simulationMode: includePdn ? "TRAN" : getProp(statEyeCfg, 'simulationMode', 'EDGE'),
      edgesNum: getProp(statEyeCfg, 'edgesNum', '2'),
      crosstalkType: getProp(statEyeCfg, 'crosstalkType', 'DDP'),
      eyeDiagramTriggering: getProp(statEyeCfg, 'eyeDiagramTriggering', 1) === 0 ? 0 : 1,
      eyeDiagramTriggeringClockMode: getProp(statEyeCfg, 'eyeDiagramTriggeringClockMode', 2),
      numberBits: getProp(statEyeCfg, 'numberBits', 100000),
      steadyState: getProp(statEyeCfg, 'steadyState', 2),
      ignoreBits: getProp(statEyeCfg, 'ignoreBits', 200),
      alignEye: getProp(statEyeCfg, 'alignEye', { mode: 'SYNC', value: "50" }),
      tolerance: getProp(statEyeCfg, 'tolerance', ["1e-20"]),
      nImpulse: getProp(statEyeCfg, 'nImpulse', ''),
    }
  }

  if (isSEV) {
    _config.hspiceLicenses = getProp(Config, 'hspiceLicenses', 2);
  } else {
    _config.hspiceCores = getProp(Config, 'hspiceCores', 2);
  }
  return _config
}

function getCopyExperimentData(expInfo, copyInfo, baseContent, isJitter) {
  let expInterfaces = expInfo && expInfo.Interfaces ? expInfo.Interfaces : [];
  let expBaseInterfaces = baseContent ? baseContent.find(item => item.id === expInfo.id) || {} : {}

  let copyBaseInterfaces = baseContent ? baseContent.find(item => item.id === copyInfo.id) || {} : {}
  let copyInterfaces = copyInfo && copyInfo.Interfaces ? copyInfo.Interfaces : [];

  const newExpInfo = getSweepCopyByteData(expInterfaces, copyInterfaces, expBaseInterfaces.Interfaces, copyBaseInterfaces.Interfaces, '', isJitter)
  return newExpInfo;
}

const IBIS_AMI = "IBIS_AMI", IBIS = "IBIS"
async function changeExpContentAMIModelToIBISModel(Interfaces) {
  if (!Interfaces || !Interfaces.length) {
    return Interfaces;
  }
  let newInterfaces = JSON.parse(JSON.stringify(Interfaces));

  for (let item of newInterfaces) {
    let _model = item.model ? item.model : [];
    for (let modelData of _model) {
      const modelInfo = modelData.modelInfo ? modelData.modelInfo : {}
      if (modelInfo.libType && [IBIS_AMI, IBIS].includes(modelInfo.libType) && modelInfo.libraryId) {
        let isAmi = await ibisAMIConstructor.getFileIsAmiPromise(modelInfo.libraryId, modelInfo.fileName);
        modelData.modelInfo = {
          ...modelData.modelInfo,
          libType: IBIS,
          isAmi: isAmi
        }
      }
    }
    let _pins = item.pins ? item.pins : [];
    for (let pinData of _pins) {
      let pinList = pinData.pinInfo ? pinData.pinInfo : {}

      for (const pinInfo of pinList) {
        const { model: pinModel } = pinInfo;
        if (pinModel && pinModel.libType && pinModel.libType === IBIS_AMI) {
          let pinIsAmi = false;
          if (pinModel.libraryId && pinModel.fileName && pinModel.modelName) {
            pinIsAmi = await ibisAMIConstructor.getModelsInFileIsAmiPromise(
              pinModel.libraryId,
              pinModel.fileName,
              pinModel.modelName
            );
          }
          pinInfo.model = {
            ...pinModel,
            libType: IBIS,
            isAmi: pinIsAmi
          };
        }
      }

      pinData.pinInfo = pinList
    }
  }
  return newInterfaces
}


async function changeSweepExpAMIModelToIBISModel(experiments) {
  let _experiments = experiments.map(item => {
    const _content = changeExpContentAMIModelToIBISModel(item.content)
    return { ...item, content: _content }
  });
  return _experiments
}

export {
  // getBaseSweepingData,
  getExpTreeNode,
  getBaseSweepingSSNData,
  getBaseSweepingContentData,
  getExperimentColumns,
  getExperimentStatus,
  getExperimentData,
  createExperimentSignalGroupUI,
  ExperimentSignalGroup,
  getPinsDiffData,
  getAMIDiffData,
  getIBISDiffData,
  getMultipleDisable,
  // getModelText,
  // getSimulationText,
  // getCornerText,
  getSimulationConfig,
  getSaveConfig,
  getSimConfigDiff,
  getComponentList,
  getCopyExperimentData,
  changeSweepExpAMIModelToIBISModel,
}
